import type { ControlledTextInputProps } from '@gurupay/gp-ui-library';
import { ControlledTextInput as ControlledTextInputUI } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ControlledTextInput: FC<ControlledTextInputProps> = ({
	rules,
	...inputProps
}) => {
	const { t } = useTranslation();

	return (
		<div className="space-y-0 max-w-[500px]">
			<ControlledTextInputUI
				{...inputProps}
				rules={{
					maxLength: {
						message: t('payments.common.maxLength', { maxLength: 255 }),
						value: 255,
					},
					...rules,
				}}
			/>
		</div>
	);
};
